
import { Button } from "@/components/ui/button";
import { Save, RotateCcw } from "lucide-react";

interface AdminSettingsHeaderProps {
  hasChanges: boolean;
  onSave: () => void;
  onReset: () => void;
}

const AdminSettingsHeader = ({ hasChanges, onSave, onReset }: AdminSettingsHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Settings</h1>
        <p className="text-muted-foreground mt-1">
          Manage your application settings and preferences
        </p>
      </div>
      
      <div className="flex items-center space-x-3">
        {hasChanges && (
          <Button
            variant="outline"
            onClick={onReset}
          >
            <RotateCcw className="h-4 w-4 mr-2" />
            Reset
          </Button>
        )}
        <Button
          onClick={onSave}
          disabled={!hasChanges}
        >
          <Save className="h-4 w-4 mr-2" />
          Save Changes
        </Button>
      </div>
    </div>
  );
};

export default AdminSettingsHeader;
